/**
 * pcg-color-map.js
 * ------------------------------------------------------------
 * Maps your store's color option names to real hex codes, so
 * swatches show an accurate color even when the name isn't a
 * valid CSS color keyword (e.g. "gun powder", "jean blue",
 * "C.Brown", "mauve").
 *
 * TO ADD OR FIX A COLOR:
 * Add a line below in the form  'name': '#hexcode',
 * Keys are matched lowercase + trimmed, so "Gun Powder",
 * "gun powder", and " Gun Powder " all match the same entry —
 * you don't need to match the exact casing used in Shopify.
 *
 * Any color NOT listed here falls back to being passed straight
 * to CSS as-is (works fine for plain names like "Black", "Pink",
 * "Red"). If the browser can't render it either, the swatch gets
 * a striped placeholder and a console warning telling you the
 * exact name to add here.
 * ------------------------------------------------------------
 */
window.PcgColorMap = {
  'white': '#FFFFFF',
  'black': '#000000',
  'maroon': '#800000',
  'wine': '#5c214f',
  'pink': '#eb2f6f',
  'l.pink':'#e0a0aa',
  'baby pink': '#F4C2C2',
  'hot pink': '#FF69B4',
  'mauve': '#B784A7',
  'onion': '#C48793',
  'onion pink': '#C48793',
  'clay': '#8a3642',
  'c.brown': '#4B3621',
  'b.green':'#043012',
  'coffee brown': '#4B3621',
  'coffee': '#6F4E37',
  'chocolate': '#7B3F00',
  'tan': '#D2B48C',
  'beige': '#F5F5DC',
  'nude': '#E3BC9A',
  'skin': '#e0caab',
  'gun powder': '#2C3539',
  'gunpowder': '#2C3539',
  'charcoal': '#36454F',
  'grey': '#808080',
  'gray': '#808080',
  'steel grey': '#71797E',
  'navy': '#000080',
  'navy blue': '#000080',
  'blue': '#0000FF',
  'jean blue': '#5D76A9',
  'royal blue': '#4169E1',
  'sky blue': '#87CEEB',
  'd.ocean': '#196272',
  'deep ocean': '#003366',
  'ice turquoise': '#649d8f',
  'turquoise': '#40E0D0',
  'teal': '#008080',
  'sea green': '#2E8B57',
  'mint green': '#98FF98',
  'olive': '#808000',
  'lavender': '#E6E6FA',
  'purple': '#800080',
  'red': '#FF0000',
  'coral': '#FF7F50',
  'peach': '#FFDAB9',
  'mustard': '#FFDB58',
  'ivory': '#FFFFF0',
  'cream': '#FFFDD0',
  'rose': '#FF007F',
  'beach':'#f4cdb3',
  'rust brown':'#8f4704',
  'peacock green':'#0f4747',
  'carrot':'#f02828',
  'rani rose':'#a2015a',
  'camel':'#aa9d71',
  'peacock green':'#002a0b',
  'aash':'#6e6f68',
  'lavender':'#8c60b3'
};
